<template>
	<main v-if="horse && horse.horse_id && !loading">
		<HeaderTab 
            :title="horse.horse_nom | multiCapitalize"
            :horse="horse"
            :presence="presence"
            horse_readonly 
            :swiper_tabs="swiper_tabs"
        />
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<!-- <div class="col-12 col-xxl-auto order-xxl-last" id="menu_compte">
						<template v-for="tab in swiper_tabs">
							<router-link
								v-if="!tab.active && !tab.hidden"
	                            class="item-menu item-menu-fiche"
	                            :to="{ name: tab.href }"
	                            :key="tab.href"
	                        >
	                            <span><span>
	                            <i v-b-tooltip.right :title="$t(tab.label)">
	                                <font-awesome-icon :icon="tab.icon" />
	                            </i></span>{{ $t(tab.label) }}</span>
	                        </router-link>
	                    </template>
					</div> -->
					<div class="col-12 col-xxl">
						<div>
							<keep-alive>
								<router-view :horse="horse"></router-view>
							</keep-alive>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>

	<main v-else>
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<div class="box" v-if="loading">
							{{ $t('global.chargement') }}
						</div>
						<div class="box" v-else>
							<HorseNotFound />
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>


<script type="text/javascript">
	import HorseMixin from "@/mixins/Horse.js"
	import ActeMixin from "@/mixins/Actes.js"

	export default {
		name: "HorseFiche",
		mixins: [
            ActeMixin,
            HorseMixin
        ],
		data () {
			return {
                loading: true,
				horse_id: 0,
				horse: {},
				presence: null,
                has_acts: false,
                has_products: false,
                swiper_tabs: []
			}
		},
		created() {
            this.$store.commit({ type: 'updatehorseFicheReadonly', val: true })
		},
		mounted() {
			this.horse_id = this.$route.params.horse_id
			this.init_component()
		},
		methods: {
			async init_component() {

				Promise.all([
					this.loadHorse()
				]).then(() => {
					this.setSwiperTab(this.$route.name)
					if(this.$route.name == 'horseFiche'){
						this.$router.replace({ name: this.actual_tab })
					}

					if(this.swiper_tabs.filter(elem => elem.href == 'HorseFicheInfo').length == 0 && this.$route.name == 'HorseFicheInfo'){
						this.$router.replace({ name: this.swiper_tabs[0].href })
					}

				}).finally(() => {
					this.loading = false
				})
				
				this.getHorseActualPlace(this.horse_id)
				.then(result => {
					this.presence = result
				})
				.catch(e => {
					this.presence = null
				})
			},
			async loadHorse() {
                const horse_id = parseInt(this.horse_id)

                // On charge les infos du cheval (en cache cond)
                this.horse = await this.getHorseById(horse_id).catch(e => {
                    console.error(e)
                    return null
                })

                this.horse.use_dedicated_recap = true // pour monceaux
                this.has_acts = this.horse.has_acts
			},
            async checkHasProducts() {
                if(!this.isMare) {
                    this.has_products = false
                    return
                }

                const temp = await this.getHorseChildren(this.horse_id).catch(e => {
                    return null
                })
                this.has_products = (temp && temp.length > 0)
            },
            setSwiperTab(tab_name = '') {
                const horseFicheTabs = this.$store.state.common.tabs.horseFiche

                // On retourne les onglets dans l'ordre de la config
                let tabs = horseFicheTabs.map(tab => {
                    return this.all_tabs.find(t => t.href == tab)
                })
                tabs.forEach(tab => tab.active = false)

                if(tab_name !== '') {
	                let idx = tabs.findIndex(elem => elem.href == tab_name)
	                if(idx > -1) {
		                tabs[idx].active = true
	                }
                }

				if(tabs.filter(elem => elem.active == true).length == 0){
					tabs[0].active = true
				}
				
				this.swiper_tabs = tabs
            }
		},
		computed: {
            all_tabs() {
                return [
					{
						label: 'global.informations',
						href: 'HorseFicheInfo',
						active: true,
						icon: ['far', 'info-circle']
					},
                    {
						label: 'global.informations',
						href: 'HorsePedigreePdf',
						active: true,
						icon: ['far', 'info-circle']
					},
					{
						label: 'global.actes',
						href : 'HorseFicheActes',
						hidden: !this.hasActesAccess || !this.has_acts,
						active: false,
						icon: ['fal', 'tasks']
					},
                    {
						label: 'global.notes',
						href : 'HorseFicheNotes',
						active: false,
						icon: ['fal', 'tasks']
					},
                    {
						label: 'horse.feed',
						href : 'HorseFeed',
						hidden: !this.hasSocialFeedAccess,
						active: false,
						icon: ['fad', 'comments-alt']
					},
					{
						label: 'monte.contract',
						href : 'ContractMareList',
						hidden: !this.hasSaillieMareAccess,
						active: false,
						icon: ['fal', 'file-contract']
					},
                    {
						label: 'horse.infos_monte',
						href : 'HorseMonteInfo',
						hidden: !this.hasMonteInfosAccess || !this.isMare || this.isFoalYearling || this.isOutOfStructure || !this.has_products,
						active: false,
						icon: ['fal', 'venus-mars']
					},
                    {
						label: 'horse.production',
						href : 'HorseProduct',
                        hidden: !this.isMare || !this.has_products,
						active: false,
						icon: ['fal', 'syringe']
					},
					{
						label: 'horse.production',
						href : 'HorseProductDedicated',
                        hidden: !this.isMare || this.isFoalYearling || this.isOutOfStructure,
						active: false,
						icon: ['fal', 'syringe']
					},
                    {
						label: 'global.perfs',
						href : 'HorsePerfs',
						hidden: !this.hasPerfsAccess || this.isFoalYearling,
						active: false,
						icon: ['fal', 'binoculars']
					},
                    {
						label: 'horse.suivi_croissance',
						href : 'HorseSuiviCroissance',
						hidden: !this.hasSuiviCroissanceAccess,
						active: false,
						icon: ['far', 'chart-area']
					},
                    {
						label: 'horse.caracterisation_pax',
						href : 'HorsePax',
						// hidden: !this.hasPaxAccess,
						active: false,
						icon: ['cf', 'pax']
					},
                    {
						label: 'horse.mouvements',
						href : 'HorseMouvements',
						hidden: !this.hasMouvementAccess,
						active: false,
						icon: ['fal', 'route']
					},
                    {
						label: 'menu.semence',
						href : 'StallionSemence',
						hidden: !this.hasSemenceAccess,
						active: false,
						icon: ['fal', 'vials'],
						dropdown: [{
							label: 'monte.semence.stocks',
							href : 'StallionStocks',
							active: false,
						},
						{
							label: 'monte.semence.commandes',
							href : 'StallionCommandes',
							active: false,
						},
						{
							label: 'monte.semence.expeditions',
							href : 'StallionExpeditions',
							active: false,
						}]
					},
                    {
						label: 'horse.tiers_contacts',
						href : 'HorseTiersContact',
						hidden: !this.hasHorseTiersContactAccess,
						active: false,
						icon: ['fal', 'user-tie']
					}
				]
            },
            actual_tab() {
                const tab = this.swiper_tabs.find(st => st.active === true)
                return tab.href
            },
            isMare() {
				return this.horse.horse_sexe == "F"
			},
			hasSaillieMareAccess() {
				return (this.horse.horse_sexe == "F") && this.$store.state.userAccess.hasSaillieAccess
			},
            hasActesAccess() {
                return this.$store.state.userAccess.hasActesAccess
            },
            hasSocialFeedAccess() {
                return this.$store.state.userAccess.hasSocialFeedAccess
            },
            hasMonteInfosAccess() {
                return this.$store.state.userAccess.hasMonteInfosAccess
            },
            hasPerfsAccess() {
                return this.$store.state.userAccess.hasPerfsStatsAccess
            },
            hasSuiviCroissanceAccess() {
            	return this.$store.state.userAccess.hasSuiviCroissanceAccess
            },
            hasPaxAccess() {
            	return this.$store.state.userAccess.hasPaxAccess
            },
            hasMouvementAccess() {
            	return this.$store.state.userAccess.hasMouvementAccess
            },
            hasSemenceAccess() {
            	return this.$store.state.userAccess.hasSemenceAccess
            },
            hasHorseTiersContactAccess() {
            	return this.$store.state.userAccess.hasHorseTiersContactAccess
            },
            routeId() {
                return this.$route.params.horse_id
            },
            isFoalYearling() {
                if(this.horse.horse_categories.length === 0) return false

                const ids_monceaux = [2, 3] // oui
                const temp = this.horse.horse_categories.find(c => ids_monceaux.indexOf(c.categorie_id) > -1)
                return !!temp
            },
            isOutOfStructure() {
                if(this.horse.horse_categories.length === 0) return false

                const ids_monceaux = [12]
                const temp = this.horse.horse_categories.find(c => ids_monceaux.indexOf(c.categorie_id) > -1)
                return !!temp
            }
		},
        watch: {
            routeId(val) {
                this.loading = true
                this.horse_id = val
                this.init_component()
            },
            isMare() {
                this.checkHasProducts()
            },
            '$route.name'(val) {
            	this.setSwiperTab(val)
            }
        },
		components: {
			HorseNotFound: () => import('GroomyRoot/components/Horse/HorseNotFound'),
			HeaderTab: () => import('GroomyRoot/components/HeaderTab'),
		}
	}
</script>
